export class DynatraceLogger {
  logError(error) {
    try {
      throw error;
    } catch (caught) {
      window.dtrum?.reportError(caught);
    }
  }
}